var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$apollo.queries.profile.loading)?_c('ProfileTemplate',{attrs:{"user":_vm.profile.edges[0].node.user}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }